export default "__VITE_ASSET__ExRw8M1f__"